import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid'
import { Card, CardHeader, ListItem } from 'components'
import { get } from 'lodash'
import { useLoadCustomer } from 'modules/customers/hooks'
import { useParams } from 'react-router-dom'
import { cnpjCpfMask, formatDate } from 'utils'

export const General = () => {
  const { id } = useParams()

  const { data: customer } = useLoadCustomer(id)

  const columnLeft = [
    {
      label: 'Razão Social',
      key: 'fullname'
    },
    {
      label: 'Fantasia/Apelido',
      key: 'fantasy'
    },
    {
      label: 'CNPJ/CPF',
      key: 'cnpjCpf',
      transform: (value: any) => cnpjCpfMask(value)
    }
  ]

  const columnRight = [
    {
      label: 'Inscrição Estadual',
      key: 'registration'
    },
    {
      label: 'Fundação/Nascimento',
      key: 'birthDate',
      transform: (value: string) => formatDate(value)
    },
    {
      label: 'Observação',
      key: 'observation'
    }
  ]
  return (
    <div>
      <Card
        sx={{
          visibility: { xs: 'hidden', sm: 'visible', md: 'visible' },
          padding: { xs: 0, sm: 0, md: 0 },
          maxWidth: 800
        }}
      >
        <Box
          sx={{
            visibility: { xs: 'visible', sm: 'visible', md: 'visible' }
          }}
        >
          <Box
            sx={{
              padding: { xs: 0, sm: '22px 24px 0 24px', md: '22px 24px 0 24px' }
            }}
          >
            <CardHeader title="Informações Gerais" />
          </Box>
          <Divider
            sx={{ visibility: { xs: 'hidden', sm: 'visible', md: 'visible' } }}
          />
          <Grid container sx={{ padding: { xs: 0, sm: '24px', md: '24px' } }}>
            <Grid item xs={12} sm={6} lg={6}>
              {columnLeft?.map((item) => (
                <ListItem
                  key={item.key}
                  label={item.label}
                  value={get(customer, item.key)}
                  transform={item.transform}
                />
              ))}
            </Grid>
            <Grid item xs={12} sm={6} lg={6}>
              {columnRight?.map((item) => (
                <ListItem
                  key={item.key}
                  label={item.label}
                  value={get(customer, item.key)}
                  // transform={item.transform}
                />
              ))}
            </Grid>
          </Grid>
        </Box>
      </Card>
    </div>
  )
}
